export type GeoVault = {
    distanceToBorder: number;
    gatewayStatus: GeoVaultGatewayStatus;
    millisecondsToNextPing: number;
    personId: string;
    areaCode?: string | null;
    geoReason?: string;
    failureCode?: string;
    type: string;
};

export const GeoVaultGatewayStatus = {
    Ok: 'OK',
    Blocked: 'BLOCKED', // location is blocked by user
    Blacklisted: 'BLACKLISTED', // out of region
    Error: 'ERROR', // incorrect or revoked client id
    Outage: 'OUTAGE', // request blocked by mmG service notification
    Limited: 'LIMITED', // User has breached Quality of Service limits
    IoTimeout: 'IO_TIMEOUT', // 3rd party timeout
    IoError: 'IO_ERROR', // error connecting to third party service
} as const;
export type GeoVaultGatewayStatus = typeof GeoVaultGatewayStatus[keyof typeof GeoVaultGatewayStatus];

export type GeoLocationCallback = {
    onAllow: () => void;
    onBlock: (pingResult: GeoLocationPingResult) => void;
    onUnavailable: () => void;
    onPermissionPrompt: () => void;
    // TODO: blacklisted, error, outage, limited, io_timeout, io_error
};

export const GeoLocationPingStatus = {
    Ok: 'Ok',
    Blocked: 'Blocked',
    Unavailable: 'Unavailable',
    PermissionPrompt: 'PermissionPrompt',
} as const;
export type GeoLocationPingStatus = typeof GeoLocationPingStatus[keyof typeof GeoLocationPingStatus];

export const GeoLocationErrorCode = {
    PermissionError: 'PermissionError',
    DevTools: 'DevTools',
    Timeout: 'Timeout',
    VpnUsage: 'VpnUsage',
    UnableToGetLocation: 'UnableToGetLocation',
    GenericError: 'GenericError',
} as const;
export type GeoLocationErrorCode = typeof GeoLocationErrorCode[keyof typeof GeoLocationErrorCode];

export type GeoLocationPingResult = OkPingResult | ErrorPingResult;

export type OkPingResult = {
    status: typeof GeoLocationPingStatus.Ok;
    geoLocationState: string;
};

export type ErrorPingResult = {
    status: Exclude<GeoLocationPingStatus, typeof GeoLocationPingStatus.Ok>;
    code?: GeoLocationErrorCode;
    clientId?: string;
};

export const GeoPermissionState = {
    PENDING: 'PENDING',
    PROMPT: 'PROMPT',
    GRANTED: 'GRANTED',
    DENIED: 'DENIED',
    UNAVAILABLE: 'UNAVAILABLE',
} as const;
export type GeoPermissionState = typeof GeoPermissionState[keyof typeof GeoPermissionState];

export const Activity = {
    Login: 'Login',
    Registration: 'Registration',
    TicketSubmit: 'TicketSubmit',
    ScheduledPing: 'ScheduledPing',
    Withdrawal: 'Withdrawal',
} as const;
export type Activity = typeof Activity[keyof typeof Activity];
